export default __webpack_public_path__ + "static/media/Email_Domains_List_Template.498de7a9.xlsx";